import React, { useEffect, useState } from 'react';
import { Select, Button, colors, InputText, useFirstRender } from '@insurancemenu/imenu-components-lib';
import { NavigationClose } from '@insurancemenu/imenu-components-lib/dist/icons';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { EeClassWithValidation } from 'types/electionService';
import { subscriberStockClasses } from 'global/utils/election/subscriberClassHelper';
import { createStyles } from './styles';

interface EeClassBlockProps {
  classIndex?: number;
  classInfo: EeClassWithValidation;
}

const EeClassBlock = observer(({ classInfo, classIndex = 1 }: EeClassBlockProps): JSX.Element => {
  const { type, name: classValue, id, periodId, groupId, validationMessage = '' } = classInfo;
  const classes = createStyles();

  const [value, setValue] = useState(classValue);
  const firstRender = useFirstRender();

  const {
    eeClassesStore: { removeClass, updateNewClass, saveTrigger, employeeClassesWithEe },
  } = useRootStore();
  const convertedEmployeeClassesWithEe = employeeClassesWithEe.map((eeClass) => toJS(eeClass));
  const stockOptions: OptionType[] = subscriberStockClasses.map((stockClass) => ({
    value: stockClass,
    label: stockClass,
  }));

  const isClassUsed = !!convertedEmployeeClassesWithEe.find(
    ({ name, id: classId }) => name === value && classId === id,
  );

  useEffect(() => {
    if (!firstRender) {
      updateNewClass(type, value, periodId, groupId, id);
    }
  }, [saveTrigger]);

  const removeEeClass = (): void => {
    removeClass(id);
  };

  return (
    <div className={classes.classWrapper}>
      {type === 'STOCK' ? (
        <Select
          label={`Class ${classIndex}`}
          name={`Stock-${value}`}
          options={stockOptions}
          value={value}
          validationPassed={!validationMessage}
          validationMessage={validationMessage}
          onChange={(e): void => {
            setValue(e.target.value);
          }}
          width="23rem"
          disabled={isClassUsed}
          className={classes.classDefaultName}
        />
      ) : (
        <InputText
          label={`Class ${classIndex}`}
          name={`${type}-${value}`}
          value={value}
          width="23rem"
          maxLength={50}
          onChange={(e): void => {
            setValue(e.target.value);
          }}
          validationPassed={!validationMessage}
          validationMessage={validationMessage}
          disabled={isClassUsed}
          className={classes.classDefaultName}
        />
      )}

      <>
        {isClassUsed ? (
          <p className={classes.warningClassMessage}>This class is used</p>
        ) : (
          <Button
            leftIconProp={<NavigationClose />}
            type="text"
            color="custom"
            customColor={colors.red[500]}
            className={classes.removeClassBtn}
            onClick={removeEeClass}
          >
            Remove
          </Button>
        )}
      </>
    </div>
  );
});

export default EeClassBlock;
